<div class="login-page">
    <div class="login-card">
        <div class="brand">
            <app-logo Width="64" Height="64"></app-logo>
        </div>

        <h1 class="title">Bienvenido</h1>
        <p class="subtitle">Colegio de Cirujanos Dentistas de Honduras</p>

        <form class="form" (ngSubmit)="fnIngresar()" novalidate>
            <label class="field">
                <span class="field-label">Usuario</span>
                <input [(ngModel)]="user" name="email" type="text" autocomplete="username"
                    placeholder="Ingrese su usuario" autofocus>
            </label>

            <label class="field">
                <span class="field-label">Contraseña</span>
                <div class="password">
                    <input [(ngModel)]="pass" name="pass" [type]="mostrarPass ? 'text' : 'password'"
                        autocomplete="current-password" placeholder="••••••••">
                    <button type="button" class="toggle" (click)="mostrarPass = !mostrarPass"
                        [attr.aria-label]="mostrarPass ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                        {{ mostrarPass ? 'Ocultar' : 'Mostrar' }}
                    </button>
                </div>
            </label>

            <button type="submit" class="submit">Ingresar</button>
        </form>

        <p class="footer">Sistema de Registro de Votación</p>
    </div>
</div>
